let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("e2RXi")).then(() => parcelRequire('iu4P9'));